module.exports = __webpack_public_path__ + "static/media/personajes.d095321f.svg";